import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

interface IPaginatedLocationResponse {
  message: string;
  payload: ILocationPayload;
}

// Response interface for simple array data (provinces, districts list)
interface ISimpleLocationResponse {
  message: string;
  payload: IContent[];
}

interface ILocationPayload {
  content: IContent[];
  page: IPageInfo;
}

export interface IContent {
  id: string;
  name: string;
}

interface IPageInfo {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  constructor(private api: ApiService) {}

  getProvinces(): Observable<ISimpleLocationResponse> {
    return this.api.GET<ISimpleLocationResponse>('locations/provinces');
  }

  getDistrictsByProvince(provinceId: string): Observable<IPaginatedLocationResponse> {
    const params = new HttpParams().set('page', '0').set('size', '100');
    return this.api.GET<IPaginatedLocationResponse>(
      `locations/districts/${provinceId}`,
      { params }
    );
  }

  getDistricts(): Observable<ISimpleLocationResponse> {
    return this.api.GET<ISimpleLocationResponse>('locations/districts');
  }

  getSectors(districtId: string): Observable<IPaginatedLocationResponse> {
    return this.api.GET<IPaginatedLocationResponse>(
      `locations/sectors/${districtId}`
    );
  }

  getCells(sectorId: string): Observable<IPaginatedLocationResponse> {
    const params = new HttpParams().set('page', '0').set('size', '100');
    return this.api.GET<IPaginatedLocationResponse>(
      `locations/cells/${sectorId}`,
      { params }
    );
  }

  getVillages(cellId: string): Observable<IPaginatedLocationResponse> {
    const params = new HttpParams().set('page', '0').set('size', '100');
    return this.api.GET<IPaginatedLocationResponse>(
      `locations/villages/${cellId}`,
      { params }
    );
  }
}
